export const studyLevel = {
  Undergraduate: 'Undergraduate',
  Graduate: 'Graduate',
  Transfer: 'Transfer',
  EnglishLanguage: 'English Language',
  ALevel: 'A Level',
};
